document.documentElement.classList.remove('no-js');

function formatMoney(cents, format) {
  const value = Number(cents || 0);
  const formatString = format || '€{{amount_with_comma_separator}}';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatWithDelimiters = (number, precision = 2, thousands = '.', decimal = ',') => {
    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split('.');
    const euros = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    return `${euros}${precision ? decimal + parts[1] : ''}`;
  };
  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;
  const replacement = match[1].includes('no_decimals')
    ? formatWithDelimiters(value, 0, '.', ',')
    : formatWithDelimiters(value, 2, '.', ',');
  return formatString.replace(placeholderRegex, replacement);
}

customElements.define('ht-menu', class extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!expanded));
      this.panel.toggleAttribute('hidden', expanded);
      document.body.classList.toggle('menu-open', !expanded);
    });
  }
});

document.addEventListener('click', (event) => {
  const cardThumb = event.target.closest('[data-card-thumb]');
  if (cardThumb) {
    const card = cardThumb.closest('[data-product-card]');
    updateProductCardImage(card, cardThumb.dataset.cardImage, cardThumb);
    return;
  }

  const cardPrev = event.target.closest('[data-card-prev]');
  const cardNext = event.target.closest('[data-card-next]');
  if (cardPrev || cardNext) {
    const card = event.target.closest('[data-product-card]');
    const thumbs = card ? Array.from(card.querySelectorAll('[data-card-thumb]:not(.is-hidden)')) : [];
    if (!thumbs.length) return;
    const currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const nextIndex = cardNext
      ? (currentIndex + 1) % thumbs.length
      : (currentIndex - 1 + thumbs.length) % thumbs.length;
    updateProductCardImage(card, thumbs[nextIndex].dataset.cardImage, thumbs[nextIndex]);
    return;
  }

  const cardVariant = event.target.closest('[data-card-variant]');
  if (cardVariant) {
    const card = cardVariant.closest('[data-product-card]');
    if (!card || cardVariant.disabled) return;

    updateProductCardVariant(card, cardVariant);
    return;
  }

  const cartMinus = event.target.closest('[data-cart-quantity-minus]');
  const cartPlus = event.target.closest('[data-cart-quantity-plus]');
  if (cartMinus || cartPlus) {
    const box = event.target.closest('.cart-quantity');
    const input = box && box.querySelector('input[type="number"]');
    if (!input) return;

    const min = Number(input.getAttribute('min') || 0);
    const current = Number(input.value || min);
    const next = cartPlus ? current + 1 : Math.max(min, current - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  const minus = event.target.closest('[data-quantity-minus]');
  const plus = event.target.closest('[data-quantity-plus]');
  if (!minus && !plus) return;

  const box = event.target.closest('.product-quantity__box');
  const input = box && box.querySelector('input[type="number"]');
  if (!input) return;

  const min = Number(input.getAttribute('min') || 1);
  const current = Number(input.value || min);
  const next = plus ? current + 1 : Math.max(min, current - 1);
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const activeVariant = card.querySelector('[data-card-variant].is-active');
    if (activeVariant) updateProductCardVariant(card, activeVariant, { init: true });
  });
});

function updateProductCardImage(card, imageUrl, activeThumb) {
  if (!card || !imageUrl) return;
  const image = card.querySelector('.product-card__image');
  if (!image) return;
  image.src = imageUrl;
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  card.querySelectorAll('[data-card-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
  if (activeThumb) {
    activeThumb.classList.add('is-active');
    scrollProductCardThumbs(card, activeThumb);
  }
}

function updateProductCardVariant(card, variantButton, options = {}) {
  if (!card || !variantButton) return;

  card.querySelectorAll('[data-card-variant]').forEach((button) => button.classList.remove('is-active'));
  variantButton.classList.add('is-active');

  const link = card.querySelector('[data-card-main-link]');
  const productLink = card.querySelector('.product-card__link');
  const titleLink = card.querySelector('.product-card__title a');
  const mobileSlides = card.querySelectorAll('[data-card-mobile-slide]');
  const url = variantButton.dataset.cardVariantUrl;

  if (url) {
    if (link) link.href = url;
    if (productLink) productLink.href = url;
    if (titleLink) titleLink.href = url;
    mobileSlides.forEach((slide) => {
      slide.href = url;
    });
  }

  const optionTokens = String(variantButton.dataset.cardVariantOptions || '')
    .split('||')
    .map((token) => token.trim().toLowerCase())
    .filter(Boolean);

  filterProductCardMedia(card, optionTokens);
  const matchingThumb = findMatchingCardThumb(card, optionTokens);
  const imageUrl = matchingThumb?.dataset.cardImage || variantButton.dataset.cardVariantImage;
  if (imageUrl) updateProductCardImage(card, imageUrl, matchingThumb);

  const matchingMobileSlide = findMatchingMobileSlide(card, optionTokens, imageUrl);
  if (matchingMobileSlide) {
    matchingMobileSlide.scrollIntoView({
      behavior: options.init ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  }

}

function filterProductCardMedia(card, optionTokens) {
  if (!card || !optionTokens.length) return;

  const thumbs = Array.from(card.querySelectorAll('[data-card-thumb]'));
  const slides = Array.from(card.querySelectorAll('[data-card-mobile-slide]'));
  const hasTaggedThumbMatch = thumbs.some((thumb) => imageTagsMatch(thumb.dataset.cardTags, optionTokens));
  const hasTaggedSlideMatch = slides.some((slide) => imageTagsMatch(slide.dataset.cardMobileTags, optionTokens));

  if (hasTaggedThumbMatch) {
    thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-hidden', !imageTagsMatch(thumb.dataset.cardTags, optionTokens));
    });
  } else {
    thumbs.forEach((thumb) => thumb.classList.remove('is-hidden'));
  }

  if (hasTaggedSlideMatch) {
    slides.forEach((slide) => {
      slide.classList.toggle('is-hidden', !imageTagsMatch(slide.dataset.cardMobileTags, optionTokens));
    });
  } else {
    slides.forEach((slide) => slide.classList.remove('is-hidden'));
  }

  const activeThumb = card.querySelector('[data-card-thumb].is-active');
  if (activeThumb && activeThumb.classList.contains('is-hidden')) {
    activeThumb.classList.remove('is-active');
  }
}

function findMatchingCardThumb(card, optionTokens) {
  if (!card || !optionTokens.length) return null;
  const thumbs = Array.from(card.querySelectorAll('[data-card-thumb]:not(.is-hidden)'));
  return thumbs.find((thumb) => {
    return imageTagsMatch(thumb.dataset.cardTags, optionTokens);
  });
}

function findMatchingMobileSlide(card, optionTokens, imageUrl) {
  if (!card) return null;
  const slides = Array.from(card.querySelectorAll('[data-card-mobile-slide]:not(.is-hidden)'));
  if (!slides.length) return null;

  const byToken = optionTokens.length && slides.find((slide) => {
    return imageTagsMatch(slide.dataset.cardMobileTags, optionTokens);
  });
  if (byToken) return byToken;

  if (!imageUrl) return null;
  return slides.find((slide) => String(slide.dataset.cardMobileImage || '') === String(imageUrl));
}

function imageTagsMatch(tagsValue, optionTokens) {
  const tags = String(tagsValue || '').toLowerCase();
  return optionTokens.some((token) => token && tags.includes(token));
}

function scrollProductCardThumbs(card, thumb, behavior = 'smooth') {
  if (!card || !thumb) return;
  const track = card.querySelector('.product-card__thumbs');
  if (!track) return;

  const trackRect = track.getBoundingClientRect();
  const thumbRect = thumb.getBoundingClientRect();
  const targetLeft = track.scrollLeft + (thumbRect.left - trackRect.left) - ((trackRect.width - thumbRect.width) / 2);

  track.scrollTo({
    left: Math.max(0, targetLeft),
    behavior
  });
}

customElements.define('variant-selects', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => this.onVariantChange());
    this.onVariantChange();
  }

  onVariantChange() {
    const form = this.closest('form');
    const idInput = form && form.querySelector('[data-variant-id]');
    const json = this.querySelector('[data-variant-json]');
    if (!idInput || !json) return;
    const options = Array.from(this.querySelectorAll('select')).map((select) => select.value);
    const variants = JSON.parse(json.textContent);
    const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
    const section = this.closest('[data-section-id]') || document;
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const badge = section.querySelector('[data-discount-badge]');
    const availability = section.querySelector('[data-availability]');
    const sku = section.querySelector('[data-sku]');
    const skuWrapper = section.querySelector('[data-sku-wrapper]');
    const moneyFormat = this.dataset.moneyFormat || section.querySelector('[data-price-wrapper]')?.dataset.moneyFormat;

    if (!variant) {
      idInput.value = '';
      if (button) button.disabled = true;
      if (buttonText) buttonText.textContent = 'Nicht verfügbar';
      if (availability) {
        availability.textContent = 'Nicht verfügbar';
        availability.className = 'is-sold-out';
      }
      return;
    }

    idInput.value = variant.id;

    if (price) price.textContent = formatMoney(variant.price, moneyFormat);
    if (comparePrice && badge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        comparePrice.classList.remove('is-hidden');
        badge.textContent = `Spare ${formatMoney(variant.compare_at_price - variant.price, moneyFormat)}`;
        badge.classList.remove('is-hidden');
      } else {
        comparePrice.textContent = '';
        comparePrice.classList.add('is-hidden');
        badge.textContent = '';
        badge.classList.add('is-hidden');
      }
    }
    if (availability) {
      availability.textContent = variant.available ? 'Verfügbar' : 'Ausverkauft';
      availability.className = variant.available ? 'is-available' : 'is-sold-out';
    }
    if (sku && skuWrapper) {
      sku.textContent = variant.sku || '';
      skuWrapper.hidden = !variant.sku;
    }
    if (button) button.disabled = !variant.available;
    if (buttonText) buttonText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    this.updateVariantMedia(section, variant, options);
  }

  updateVariantMedia(section, variant, selectedOptions) {
    const gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const mediaItems = Array.from(gallery.querySelectorAll('[data-product-media]'));
    if (!mediaItems.length) return;

    const normalizedOptions = selectedOptions.map((option) => String(option || '').trim().toLowerCase()).filter(Boolean);
    const hasTaggedMatch = mediaItems.some((item) => {
      const tags = String(item.dataset.mediaOptionTags || '')
        .split('||')
        .map((tag) => tag.trim().toLowerCase())
        .filter(Boolean);
      return tags.some((tag) => normalizedOptions.includes(tag));
    });
    let visibleCount = 0;

    mediaItems.forEach((item) => {
      const tags = String(item.dataset.mediaOptionTags || '')
        .split('||')
        .map((tag) => tag.trim().toLowerCase())
        .filter(Boolean);

      const matchesSelectedOption = tags.some((tag) => normalizedOptions.includes(tag));
      const shouldShow = hasTaggedMatch ? matchesSelectedOption : true;

      item.classList.toggle('is-hidden', !shouldShow);
      item.classList.remove('is-active');
      if (shouldShow) visibleCount += 1;
    });

    if (!visibleCount) {
      mediaItems.forEach((item) => item.classList.remove('is-hidden'));
    }

    const mediaId = this.getVariantMediaId(variant);
    const activeItem = mediaId && gallery.querySelector(`[data-media-id="${mediaId}"]`);
    const fallbackItem = gallery.querySelector('[data-product-media]:not(.is-hidden)');
    const targetItem = activeItem && !activeItem.classList.contains('is-hidden') ? activeItem : fallbackItem;

    if (targetItem) {
      targetItem.classList.remove('is-hidden');
      targetItem.classList.add('is-active');
      if (window.matchMedia('(max-width: 989px)').matches) {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    if (variant.image && variant.image.id) return String(variant.image.id);
    return null;
  }
});
